<style lang="scss" scoped>
.certificate {
  text-align: center;
  padding: 60px 0;
  .step_1 {
    max-width: 450px;
    margin: auto;
    .logos {
      label {
        display: flex;
        justify-content: center;
        width: 100%;
        margin: 20px 10px;
        input {
          margin: auto 20px auto 0
        }
        img {
          width: auto;
          height: 50px;
        }
      }
    }
    .cpf {
        margin: 20px auto;
        max-width: 280px;

        strong {
          align-self: center;
          padding: 0 0.5rem;
        }
      }
  }
  .step_2 {
    max-width: 450px;
    margin: 20px auto;
    .otp {
      display: flex;
      flex-direction: column;
      width: 240px;
      margin: 30px auto;
      padding-left: 1em;
      input {
        width: auto;
        font-size: 2em;
        font-family: monospace;
        border: 0;
        letter-spacing: 16px;
        padding-left: 10px;
        &:focus {
          box-shadow: none;
          border: 0 !important
        }
      }
      >span {
        margin-top: -10px
      }
      b {
        font-family: monospace;
        font-size: 2em;
        border-bottom: 2px solid black;
        width: 1em;
        margin-left: 3px;
        display: inline-block;
      }
    }
    .validityDays {
      display: flex;
      flex-direction: column;
      width: 240px;
      margin: 30px auto;
      padding-left: 1em;
      select {
        width: auto;
        border: 0;
        letter-spacing: 16px;
        padding-left: 10px;
        &:focus {
          box-shadow: none;
          border: 0 !important
        }
      }
      >span {
        margin-top: -10px
      }
      b {
        font-family: monospace;
        font-size: 2em;
        border-bottom: 2px solid black;
        width: 1em;
        margin-left: 3px;
        display: inline-block;
      }
    }
  }
  .step_3, .step_4 {
    max-width: 450px;
    margin: 20px auto;
  }
}
</style>

<template>
  <article class="minhaconta__body certificate">
    <transition name="fade" mode="out-in">
      <div class="step_1" key="1" v-if="step === 1">
        <!-- <p>Selecione sua certificadora digital <span v-if="!dataForm.user.cpf && 1 == 2">e preencha seu cpf</span></!-->
        <p class="max-w-sm text-left">
          Integre seu Certificado Digital Bird ID para que os documentos
          emitidos sejam assinados e autenticados digitalmente, em conformidade
          com o padrão ICP Brasil, de acordo com a portaria do MS 467/2020 e
          com validade nacional.
          <br><br>
          Caso já tenha o certificado digital Bird ID clique em avançar para vinculá-lo.
        </p>
        <div class="flex-space_between logos">
          <!-- <label for="valid">
            <input id="valid" v-model="cert" :value="1" type="radio" name="cert" />
            <img :src="'/static/img/logo-valid.png'" alt="">
          </label> -->
          <label for="soluti">
            <input id="soluti" v-model="cert" :value="2" type="radio" name="cert" v-show="false" />
            <img :src="'/static/img/logo-soluti.png'" alt="">
          </label>
        </div>
        <label for="cpf" class="form-group cpf d-flex">
          <strong>CPF</strong>
          <input
            type="text"
            v-mask="CPF_MASK"
            :disabled="dataForm.user.cpf && 1 === 1"
            placeholder="digite seu CPF"
            v-model="cpf"
            class="form-input"
            id="cpf">
        </label>
        <button @click="step = 2" :disabled="!cert || !cpf" class="btn btn-primary">Avançar</button>

        <!-- Link para comprar certificado digital -->
        <p style="padding-top: 3rem; font-weight: 600; font-size: 0.7rem;">
          Ainda não tem o certificado digital?
          <a href="https://arsp.acsoluti.com.br/site/emissao-online" target="_blank">
            Clique aqui para comprar.
          </a>
        </p>
      </div>
      <div class="step_2" key="2" v-if="step === 2">
        <p>Digite o código OTP</p>
        <label for="otp" class="form-group otp d-flex">
          <input
            type="text"
            v-mask="'######'"
            v-model="otp"
            size="7"
            class="form-input"
            id="otp" />
          <span class="text-left">
            <b v-for="i in 6" :key="'b' + i"></b>
          </span>
        </label>

        <p>Selecione o período (em dias) de validade do código</p>
        <label for="validityDays" class="form-group validityDays d-flex">
          <select v-model="validityDays" id="validityDays">
            <option disabled value="">Escolha um abaixo</option>
            <option value="1">1</option>
            <option value="3">3</option>
            <option value="7">7</option>
          </select>
        </label>
        <button @click="step = 1"  :disabled="sending" class="btn btn-default">voltar</button>
        <button :disabled="!validForm()" @click="submit()" class="btn btn-primary">Avançar</button>
      </div>

      <div class="step_3" key="3" v-if="step === 3">
        <p>
          <big><strong>
            Sua credencial junto a certificadora foi criada com sucesso! <br>
            Suas receitas médicas, atestados e pedidos de exames serão automaticamente
            assinados após salvar os documentos durante o atendimento ao paciente. <br>
            Lembre-se que estes documentos são enviados automaticamente para o endereço
            de e-mail do paciente após o término da consulta.
          </strong></big>
        </p>
      </div>

      <div class="step_4" key="4" v-if="step === 4">
        <p>
            Sua credencial está valida e você automaticamente continua assinando digitalmente
            os documentos médicos gerados durante o atendimento ao paciente. <br>

            A credencial expira em {{ expirationTime }}. <br>
            Não se preocupe, você será notificado previamente para renovar o token.
        </p>
      </div>
    </transition>
  </article>
</template>

<script>
export default {
  props: [
    'dataForm'
  ],
  data () {
    return {
      step: 1,
      cpf: null,
      cert: 2,
      otp: null,
      sending: false,
      validityDays: 1,
      isAuthorization: true,
      fromRoute: null
    }
  },
  computed: {
    getUrlSuffix () {
      return this.isAuthorization ? 'integration_authorize' : 'credential'
    },
    getUrlPreffix () {
      return this.isAuthorization ? 'user' : 'doctor'
    }
  },
  created () {
    if (this.dataForm.user.cpf) {
      this.cpf = this.dataForm.user.cpf
    }

    if (!this.cpf) {
      this.$store.dispatch('setModalConfirm', {
        title: 'Atenção',
        body: `Para prosseguir, é necessário completar seus
          dados pessoais através da aba "Meus Dados".
        `,
        confirmText: 'Atualizar meus dados',
        size: 'md',
        active: true,
        beforeClose: (v) => {
          this.$router.push({ name: 'DoctorUser' })
          this.$store.dispatch('setModalConfirm')
          location.reload()
        }
      })
    }
  },
  mounted () {
    this.fn_HIDE_PROGRESS()
    this.fetchIntegrationStatus()
  },
  methods: {
    submit () {
      this.fn_SHOW_PROGRESS()

      let data = {
        'soluti_cess_credential': {
          otp: this.otp,
          validityDays: this.validityDays
        }
      }

      this.sending = true

      this.$http.post(
        `/${this.getUrlPreffix}/soluti_cess/${this.getUrlSuffix}`,
        data,
        this.$store.getters.getAuthHeader
      ).then(() => {
        this.step = 3
        this.$store.dispatch('setNewCertifierCredentialRequired', false)

        // waits 3 seconds and then
        // redirect to app integration if from there
        if (this.fromRoute) {
          setTimeout(() => {
            this.$router.push({ name: this.fromRoute })
          }, 3000)
        }
      }).catch((err) => {
        console.log(err)
        let msg = 'Não foi possível validar a credencial.'
        if (err.response && err.response.status === 424) {
          msg = 'O serviço de assinatura digital do parceiro Soluti está enfrentando problemas. Por favor, tente novamente mais tarde.'
        }
        this.$store.dispatch('setModalAlert', {
          title: 'Aviso',
          body: msg,
          size: 'md',
          active: true
        })
      }).finally(() => {
        this.sending = false
        this.fn_HIDE_PROGRESS()
      })
    },
    validForm () {
      let valid = true
      if (this.sending) {
        valid = false
      }
      if (!this.otp) {
        valid = false
      } else if (this.otp.length < 6) {
        valid = false
      }
      return valid
    },
    fetchIntegrationStatus () {
      this.$http.get(
        '/doctor/soluti_cess/credential?order[u.createdAt]=DESC&itensPerPage=1',
        this.$store.getters.getAuthHeader
      ).then(({data}) => {
        if (data.data && data.data.length) {
          // take the last credential
          const credentialExpiration = data.data[data.data.length - 1].credentialExpiresAt

          const expirationDate = this.$moment(credentialExpiration)
          const nowDate = this.$moment(new Date())

          const diff = nowDate.diff(expirationDate, 'hours')

          if (diff <= -2) {
            this.step = 4
            this.expirationTime = expirationDate.format('DD/MM/YYYY à\\s HH:mm')
            return
          }
        }
        // in this case, integration already exists, so it's only credential
        this.isAuthorization = false
        this.cert = 2 // set soluti as default
        this.step = 2 // jump to step 2
      }).catch(() => {
        // in this case, integration does not exist
        this.isAuthorization = true
      })
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      if (/appintegration/gi.test(from.name)) {
        vm.fromRoute = from.name
      }
    })
  }
}
</script>
